import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SupportModalComponent } from '../component';

@Injectable({
  providedIn: 'root',
})
export class RebalancingErrorTrackerService {
  private readonly STORAGE_KEY_COUNT = 'rebalancing-consecutive-error-count';
  private readonly CONSECUTIVE_ERROR_THRESHOLD = 2;

  private consecutiveErrors = 0;
  private showSupportModalSubject = new BehaviorSubject<boolean>(false);

  public showSupportModal$: Observable<boolean> =
    this.showSupportModalSubject.asObservable();

  constructor() {
    this.loadErrorCount();
  }

  public recordError(): void {
    this.consecutiveErrors++;
    this.saveErrorCount();

    const isHidden =
      localStorage.getItem(SupportModalComponent.STORAGE_KEY_HIDE) === 'true';

    if (
      !isHidden &&
      this.consecutiveErrors >= this.CONSECUTIVE_ERROR_THRESHOLD
    ) {
      this.triggerSupportModal();
    }
  }

  public recordSuccess(): void {
    this.consecutiveErrors = 0;
    this.saveErrorCount();
  }

  private triggerSupportModal(): void {
    this.showSupportModalSubject.next(true);
  }

  private saveErrorCount(): void {
    localStorage.setItem(
      this.STORAGE_KEY_COUNT,
      this.consecutiveErrors.toString(),
    );
  }

  private loadErrorCount(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY_COUNT);
    this.consecutiveErrors = saved ? parseInt(saved, 10) : 0;
  }
}
